import React from "react";
import { Box, Chip, Stack, TextField, Typography, useTheme } from "@mui/material";

const CATEGORY_OPTIONS = [
  "Atrasos",
  "Avisos",
  "Faturas",
  "Inadimplências",
  "Marketing",
  "Outros",
];

export function StepBasicInfo({ data, updateData, setIsValid, showErrors }) {
  
  const theme = useTheme();

  const title = data.title?.trim() || "";
  const description = data.description?.trim() || "";
  const category = data.category || "";

  const isValid = Boolean(title && description && category);

  React.useEffect(() => {
    setIsValid(isValid);
  }, [isValid, setIsValid]);

  return (
    <Box sx={{ width: "100%" }}>
      {/* Título */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 14, mb: 1 }}>Título da Campanha</Typography>

        <TextField
          fullWidth
          placeholder="Título da Campanha"
          value={data.title || ""}
          onChange={(e) => updateData({ title: e.target.value })}
          error={showErrors && !title}
          helperText={showErrors && !title ? "Campo obrigatório" : ""}
          sx={{
            maxWidth: 420,
            "& .MuiOutlinedInput-root": { borderRadius: 2 },
          }}
        />
      </Box>

      {/* Descrição */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 14, mb: 1 }}>
          Descrição da Campanha
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={2}
          maxRows={4}
          placeholder="Descrição da Campanha"
          value={data.description || ""}
          onChange={(e) => updateData({ description: e.target.value })}
          error={showErrors && !description}
          helperText={showErrors && !description ? "Campo obrigatório" : ""}
          sx={{
            maxWidth: 420,
            "& .MuiOutlinedInput-root": { borderRadius: 2 },
          }}
        />
      </Box>

      {/* Categoria */}
      <Box>
        <Typography sx={{ fontSize: 14, mb: 1.5 }}>Categoria</Typography>

        <Stack direction="row" spacing={1.5} sx={{ flexWrap: "wrap", gap: 1 }}>
          {CATEGORY_OPTIONS.map((c) => {
            const selected = category === c;

            return (
              <Chip
                key={c}
                label={c}
                clickable
                onClick={() => updateData({ category: c })}
                sx={{
                  borderRadius: "999px",
                  px: 1,
                  p: 2,
                  backgroundColor: selected
                    ? theme.palette.custom.purple[500]
                    : theme.palette.custom.gray[300],

                  "& .MuiChip-label": {
                    color: selected ? "#fff" : theme.palette.custom.gray[700],
                    fontWeight: 600,
                  },

                  border:
                    showErrors && !category
                      ? `1px solid ${theme.palette.error.main}`
                      : "none",

                  "&:hover": {
                    backgroundColor: selected
                      ? theme.palette.custom.purple[700]
                      : theme.palette.custom.gray[400],
                  },
                }}
              />
            );
          })}
        </Stack>

        {showErrors && !category && (
          <Typography sx={{ color: theme.palette.error.main, mt: 1, fontSize: 12 }}>
            Selecione uma categoria
          </Typography>
        )}
      </Box>
    </Box>
  );
}